"use client";

import { createContext } from "react";

export type ThemePreference = "light" | "dark" | "system";
export type ResolvedTheme = "light" | "dark";

export type ThemeContextValue = {
  mounted: boolean;
  theme: ResolvedTheme;
  themePreference: ThemePreference;
  setTheme: (theme: ThemePreference) => void;
  toggle: () => void;
  isDark: boolean;
};

export const ThemeContext = createContext<ThemeContextValue | null>(null);